/* ============
 * Actions for the user module
 * ============
 *
 * The actions that are available on the
 * user module.
 */
import axios from 'axios'

export default {
  updateEventLogNps ({commit}, payload) {
    commit('setTaggeoNps', payload)
  },
  getNps () {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.get(api + 'nps/popups')
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  sendNps ({dispatch}, data) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      axios.post(api + 'surveys/responses', data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/nps/actions.js